import currency from 'currency.js'
export default class CountUp {
  constructor () {
    this.init()
  }

  init() {
    $('.counter').each(function () {
      let that = $(this),
          number = that.attr('data-count');

      if (isNaN(number)) return false;

      let countTo = parseInt(number),
          duration = countTo < 999 ? 2000 : (
                countTo < 9999 ? 2500 : 3000
              );



      let formattedNumber = that.attr('data-formatted-number');

      $({ countNum: that.text() }).animate({
        countNum: countTo,
      }, {
        duration: duration,
        easing: 'linear',
        step: function () {
          let value = Math.floor(this.countNum)

          if (formattedNumber) {
            if (number % 1 != 0) {
              value = currency(value, { symbol: '', decimal: '.', separator: ',', precision: 1 }).format()
            } else {
              value = currency(value, { symbol: '', decimal: '.', separator: ',', precision: 0 }).format()
            }
          }

          that.text(value);
        },
        complete: function () {
          let value = this.countNum

          if (formattedNumber) {
            if (number % 1 != 0) {
              value = currency(value, { symbol: '', decimal: '.', separator: ',', precision: 1 }).format()
            } else {
              value = currency(value, { symbol: '', decimal: '.', separator: ',', precision: 0 }).format()
            }
          }

          that.text(value);
        },
      });
    });
  }
}
